<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Agenda Surat Masuk</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nama</th>
                            <th style="width: 27%">Instansi</th>
                            <th style="width: 20%">Judul</th>
                            <th class="text-center" style="width: 10%">Tgl</th>
                            <th style="width: 18%"></th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" >
                              <td class="text-center">1.</td>
                              <td>Kiken Sukma Batara</td>
                              <td>Dinas Kominfo</td>
                              <td>Permohonan Domain</td>
                              <td class="text-center">20-11-2018</td>
                              <td class="text-center" >
                                <button class="btn bg-blue btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_lihat_surat">
                                    <i class="material-icons" >find_in_page</i>
                                </button>
                                &nbsp;
                                <button class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                        &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>
                        &nbsp;
                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Jenis Surat</span>
                                                <select v-model="jenis" class="form-control" >
                                                    <option>Elektronik</option>
                                                    <option>Manual</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Sifat Surat</span>
                                                <select v-model="sifat" class="form-control" >
                                                    <option>Biasa</option>
                                                    <option>Penting</option>
                                                    <option>Pribadi</option>
                                                    <option>Rahasia</option>
                                                    <option>Segera</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Type Surat/Template/Borang Acu</span>
                                                <select v-model="type" class="form-control" >
                                                    <option>Permohonan</option>
                                                    <option>Peraturan</option>
                                                    <option>Keputusan</option>
                                                    <option>Pedoman</option>
                                                    <option>Petunjuk Pelaksanaan</option>
                                                    <option>Instruksi</option>
                                                    <option>SOP</option>
                                                    <option>Surat Edaran</option>
                                                    <option>Surat Perintah</option>
                                                    <option>Surat Dinas</option>
                                                    <option>Memorandum</option>
                                                    <option>Nota Dinas</option>
                                                    <option>Surat Undangan</option>
                                                    <option>Surat Perjanjian</option>
                                                    <option>Surat Kuasa</option>
                                                    <option>Berita Acara</option>
                                                    <option>Surat Keterangan</option>
                                                    <option>Surat Pengantar</option>
                                                    <option>Pengumuman</option>
                                                    <option>Laporan</option>
                                                    <option>Telaahan Staf</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Judul Surat</span>
                                                <input v-model="judul" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Perihal</span>
                                                <input v-model="perihal" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Nomor Surat</span>
                                                <input v-model="nomor" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat PenandaTangan</span>
                                                <input v-model="penanda_tangan" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat Pemeriksa</span>
                                                <input v-model="pemeriksa" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="editor1"></textarea>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Lampiran</span>
                                                <input @change="onFileSelected" type="file" id="fileku" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <br>
                                                <button type="button" class="btn btn-block btn-lg btn-info waves-effect" data-toggle="modal" data-target="#m_tambah_penerima">PILIH UNIT PENERIMA</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">KIRIM</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH PENERIMA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_penerima" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content" style="background: #d6d6d6">
                                    <div class="modal-header bg-light-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="table-responsive" style="background: #ffffff">
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">No.</th>
                                                        <th style="padding-left:2%; width: 90%">Unit Kerja</th>
                                                        <th style="width: 5%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template>
                                                        <tr class="h_isitable">
                                                            <td class="text-center">01</td>
                                                            <td style="padding-left:2%">xxxxxxxxxx</td>
                                                            <td >
                                                                <button class="btn bg-grey btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                    <i class="material-icons" >send</i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                
                                            </table>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH PENERIMA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lihat_surat" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content" style="background: #d6d6d6">
                                    <div class="modal-header bg-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="table-responsive" style="background: #ffffff">
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">No.</th>
                                                        <th style="padding-left:2%; width: 90%">Unit Kerja</th>
                                                        <th style="width: 5%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">01</td>
                                                        <td style="padding-left:2%">xxxxxxxxxx</td>
                                                        <td >
                                                            <button class="btn bg-grey btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                                <i class="material-icons" >send</i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                
                                            </table>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                    <div class="modal-body">

                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Jenis Surat</span>
                                                <select v-model="jenis" class="form-control" >
                                                    <option>Elektronik</option>
                                                    <option>Manual</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Sifat Surat</span>
                                                <select v-model="sifat" class="form-control" >
                                                    <option>Biasa</option>
                                                    <option>Penting</option>
                                                    <option>Pribadi</option>
                                                    <option>Rahasia</option>
                                                    <option>Segera</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Type Surat/Template/Borang Acu</span>
                                                <select v-model="type" class="form-control" >
                                                    <option>Permohonan</option>
                                                    <option>Peraturan</option>
                                                    <option>Keputusan</option>
                                                    <option>Pedoman</option>
                                                    <option>Petunjuk Pelaksanaan</option>
                                                    <option>Instruksi</option>
                                                    <option>SOP</option>
                                                    <option>Surat Edaran</option>
                                                    <option>Surat Perintah</option>
                                                    <option>Surat Dinas</option>
                                                    <option>Memorandum</option>
                                                    <option>Nota Dinas</option>
                                                    <option>Surat Undangan</option>
                                                    <option>Surat Perjanjian</option>
                                                    <option>Surat Kuasa</option>
                                                    <option>Berita Acara</option>
                                                    <option>Surat Keterangan</option>
                                                    <option>Surat Pengantar</option>
                                                    <option>Pengumuman</option>
                                                    <option>Laporan</option>
                                                    <option>Telaahan Staf</option>
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Judul Surat</span>
                                                <input v-model="judul" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Perihal</span>
                                                <input v-model="perihal" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Nomor Surat</span>
                                                <input v-model="nomor" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <div class="row padding-input">
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat PenandaTangan</span>
                                                <input v-model="penanda_tangan" type="text" class="form-control padding-input">
                                            </div>
                                            <div class="col-md-6">
                                                <span class="h_title">Pejabat Pemeriksa</span>
                                                <input v-model="pemeriksa" type="text" class="form-control padding-input">
                                            </div>
                                        </div>
                                        <br>
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="e_editor1"></textarea>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>
    // var aa = CKEDITOR.instances.editor1.getData()
    const ADD_URL = URL_APP+'api/v1/office_surat_kirim/';


    export default {
    name: "monev_kabupaten",
    data() {
        return {
            jenis : 'Elektronik',
            sifat : 'Biasa',
            type : 'Permohonan',
            judul : '',
            perihal : '',
            nomor : '',
            penanda_tangan : '',
            pemeriksa : '',
            isi : '',
            fileku : null,
            penerima : [],

            list_data: [],
            page_first: 1,
            page_last: 0,
            cari_value: ""
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        onFileSelected : function(event){
            this.fileku = event.target.files[0];
        },
        addPenerima : function(){
            penerima.push({nama : nama, instansi : instansi})
        },
        addData : function(){
            var formData = new FormData();
            var fileField = document.querySelector("input[type='file']");

            formData.append('username', 'abc123');
            formData.append('isi', CKEDITOR.instances.editor1.getData());
            formData.append('file', this.fileku);
           
            fetch (ADD_URL+'surat_kirim', {
              method : 'POST',
              headers : {
                authorization: "kikensbatara " + localStorage.token
              },
              body : formData
            }).then((res_data)=>{
                this.alertku("success", "sukses menambah data");
                // this.getData();
                console.log(res_data);
                
            });
        },




        // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev: function() {
            if (this.page_first > 1) {
                this.page_first--;
            } else {
                this.page_first = 1;
            }
            this.getView();
            },

            btn_next: function() {
            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last;
            } else {
                this.page_first++;
            }
            this.getView();
            },

            cari_data: function() {
            this.getView();
            },
            getNama : function(){
            var unit_Kerja = document.getElementById("unit_kerja_id").value;
            this.autocompleted1(unit_Kerja)
            },
        // ================== PAGINASI ====================


    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        localStorage.sidemenu = 'office';
        CKEDITOR.replace( 'editor1',{
            // width: 793.700787,
            height: 1122.519685,
            
        });

        CKEDITOR.replace( 'e_editor1',{
            // width: 793.700787,
            height: 1122.519685,
            
        });
    },
    };
</script>
